import React, { useState } from "react";
import Guideline from "./Guideline";

function NameQuestion(props) {
  const [inputs, setInputs] = useState({});

  const getDefaultName = (which) => {
    let defaultValue = props.defaultName === undefined ? "" : props.defaultName;
    let splitName = defaultValue.split(" ");

    if (splitName.length > which) {
      return splitName[which];
    } else return "";
  };
  const handleValue = (event) => {
    const name = event.target.id;
    const value = event.target.value;
    const iType = event.target.type;

    //console.log(`N:${name} V: ${value} Type: ${iType}`);
    setInputs((values) => ({
      ...values,
      [name]: { val: value, valType: iType },
    }));
    props.handleValue(event);
  };

  function getName() {
    var output = "";
    if (inputs.Name_First) {
      output += inputs.Name_First.val.trim();
    }
    if (inputs.Name_Last) {
      output += " " + inputs.Name_Last.val.trim();
    }
    if (inputs.Name_Suffix) {
      output += " " + inputs.Name_Suffix.val.trim();
    }
    return output;
  }

  return (
    <li id={"Name_li"}>
      <label className="description" htmlFor="Name_First">
        Name
      </label>
      <span>
        <input
          id="Name_First"
          name="Name_First"
          className="element text"
          maxLength="255"
          size="8"
          defaultValue={getDefaultName(0)}
          type="text"
          onBlur={(event) => {
            handleValue(event);
          }}
          required
        />
        <label className="tam">First</label>
      </span>
      <span>
        <input
          id="Name_Last"
          name="Name_Last"
          className="element text"
          maxLength="255"
          size="8"
          type="text"
          defaultValue={getDefaultName(1)}
          onBlur={(event) => {
            handleValue(event);
          }}
          required
        />
        <label className="tam">Last</label>
      </span>
      <span>
        <input
          id="Name_Suffix"
          name="Name_Suffix"
          className="element text"
          maxLength="255"
          size="3"
          type="text"
          defaultValue={getDefaultName(2)}
          onBlur={(event) => {
            handleValue(event);
          }}
        />
        <label>Suffix</label>
      </span>
      <span>{getName()}</span>
      <Guideline>
        Suffix can be used to differentiate between two profiles with the same
        name, such as Jr, Sr, "Test1" or left blank. Data with the same name
        will be saved under the same individual.
      </Guideline>
    </li>
  );
}

export default NameQuestion;
